module.exports = __webpack_public_path__ + "img/Economics.ba8e167f.png";